<template>
    <div>
        <PageTitle :title="$t('baja.titulo')"></PageTitle>
        <FirstBanner></FirstBanner>
        <section class="padding-vertical-content">
            <div class="container">
                <div class="row" v-if="!baja">
                    <div class="col-12 text-center">
                        <p>
                            {{ $t('baja.recuerda') }}
                            <br>
                            {{ $t('baja.no_vuelta') }}
                        </p>
                    </div>
                    <div class="col-12 text-center">
                        <button class="button large-button sitecolor-content" @click="darDeBaja">
                            {{ $t('baja.dar_baja') }}
                        </button>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 text-center">
                        <h2>
                            {{ $t('baja.nos_vemos') }}
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import PageTitle from '@/components/frontend/shared/PageTitle';
import FirstBanner from '@/components/frontend/shared/FirstBanner';

export default {
    data() {
        return {
            baja: false,
            loading: false
        }
    },
    head: {
        title: function() {
            return {
                inner: 'Baja emails',
                complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
            }                         
        },
        meta: function() {
            return [
                {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
            ]                
        },
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        darDeBaja() {
            var email = this.$route.query.email;
            this.loading = true;

            const params = {
                filters: {
                    tid : this.configuracion.hash_teatro
                },
                email: email
            }

            this.$store.dispatch(this.config.getVuexAlias('emails.baja'), params).then(res => {
                this.baja = true;
            }).finally(() => this.loading = false);
        }
    },
    components: {
        PageTitle, FirstBanner
    }
}
</script>
